import { QueryKey, MutationKey } from '@tanstack/react-query';

export const corpIntegrationsQueryKeys: QueryKey = ['corp', 'integrations', 'query'];
export const integrationGetKeys: QueryKey = ['admin', 'integration', 'get'];

export const setupIntegrationMutationKey: MutationKey = ['integration', 'setup'];
export const setupPostbackIntegrationMutationKey: MutationKey = ['integration', 'setupPostback'];
export const updateIntegrationMutationKey: MutationKey = ['integration', 'update'];
export const deleteIntegrationMutationKey: MutationKey = ['integration', 'delete'];
